import {
  FormGsapAccessType,
  FormSalesforceResponse,
  Security,
  WorkDayRolesResponse,
} from "./types";
import { httpClient } from "./httpClient";

export async function getFormFinanceSecurityOpitons(): Promise<Security[]> {
  try {
    const { data } = await httpClient.get(
      `/api/v1/forms/form-finance/security`
    );
    return data.securities;
  } catch (error) {
    throw error;
  }
}

export async function getFormGsapAccessTypes(): Promise<FormGsapAccessType[]> {
  try {
    const { data } = await httpClient.get(`/api/v1/forms/form-gsap/security`);
    return data.accessTypes;
  } catch (error) {
    throw error;
  }
}

export async function getFormSalesForce(): Promise<FormSalesforceResponse> {
  try {
    const { data } = await httpClient.get(
      `/api/v1/forms/salesforce-form/user-types-roles`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getFormWorkDay(): Promise<WorkDayRolesResponse> {
  try {
    const { data } = await httpClient.get(`/api/v1/forms/workday/roles`);
    return data;
  } catch (error) {
    throw error;
  }
}
